import React, { useState } from 'react'
import { EyeIcon } from '@heroicons/react/24/outline'
import TextEditor from '../Common/TextEditor/TinyEditor'

const ROUTES = [
    {
        parent: { value: '/', label: '🏠 Accueil' },
        children: []
    },
    {
        parent: { value: '/dashboard', label: '📊 Tableau de bord' },
        children: []
    },
    {
        parent: { value: '/produits', label: '🛍️ Produits' },
        children: []
    },
    {
        parent: { value: '/clients', label: '👥 Clients' },
        children: [
            { value: '/clients/:userId', label: '👤 Vue client' },
            { value: '/clients/:userId/capsule', label: '💊 Capsules client' },
            { value: '/clients/:userId/capsule/:capsuleId', label: '🔍 Détail capsule' },
            { value: '/clients/:userId/commander', label: '🛒 Commander' }
        ]
    },
    {
        parent: { value: '/melanges', label: '🧪 Mélanges' },
        children: [
            { value: '/melanges/personnalises', label: '🎨 Mélanges personnalisés' },
            { value: '/melanges/catalogue', label: '📚 Catalogue' }
        ]
    },
    {
        parent: { value: '/selections', label: '📋 Sélections' },
        children: [
            { value: '/selections/:id', label: '📋 Sélection spécifique' },
            { value: '/selections/commander/:selectionId', label: '🛒 Commander sélection' }
        ]
    },
    {
        parent: { value: '/mes-capsules', label: '💊 Mes capsules' },
        children: []
    },
    {
        parent: { value: '/mon-compte', label: '👤 Mon compte' },
        children: [
            { value: '/mon-compte/commandes', label: '📦 Commandes' },
            { value: '/mon-compte/transactions', label: '💰 Transactions' },
            { value: '/mon-compte/informations', label: 'ℹ️ Informations' },
        ]
    },
    {
        parent: { value: '/admin', label: '🔧 Administration' },
        children: [
            { value: '/admin/therapeutes', label: '👨‍⚕️ Thérapeutes' },
            { value: '/admin/clients', label: '👥 Gestion clients' },
            { value: '/admin/capsules', label: '💊 Gestion capsules' },
            { value: '/admin/melanges', label: '🧪 Gestion mélanges' },
            { value: '/admin/selections', label: '📋 Gestion sélections' },
            { value: '/admin/popups', label: '🔔 Configuration popups' }
        ]
    }
]

const PopupForm = ({ 
    popupForm, 
    setPopupForm, 
    temporaryContent, 
    setTemporaryContent, 
    isLoading, 
    isCreating, 
    onPreview, 
    onSubmit, 
    onCancel 
}) => {
    // Fonction pour gérer le changement de la date de fin
    const handleEndDateChange = (e) => {
        const value = e.target.value;
        // Convertir chaîne vide en null pour l'envoi, mais garder chaîne vide pour l'affichage
        setPopupForm({ ...popupForm, endDate: value });
    };

    // Fonction pour préparer les données avant envoi
    const handleSubmit = () => {
        const formData = {
            ...popupForm,
            endDate: popupForm.endDate === '' ? null : popupForm.endDate
        };
        onSubmit(formData);
    };
    return (
        <>
            <h3 className='text-xl font-bold mb-4'>
                {isCreating ? 'Créer un nouveau popup' : 'Modifier le popup'}
            </h3>
            <div className='form-control space-y-4 gap-4'>
                <div>
                    <label className='label'>
                        <span className='label-text font-medium'>Titre</span>
                    </label>
                    <input
                        type='text'
                        className='input input-bordered w-full'
                        placeholder='Titre du popup'
                        value={popupForm.title}
                        onChange={(e) => setPopupForm({ ...popupForm, title: e.target.value })}
                    />
                </div>

                <div className='min-h-[350px]'>
                    <label className='label'>
                        <span className='label-text font-medium'>Contenu</span>
                    </label>
                    <TextEditor
                        initialValue={popupForm.content}
                        onSave={(value) => setTemporaryContent(value)}
                        debounceTime={0}
                        showSaveIndicator={true}
                        containerHeight='350px'
                        editorHeight='350px'
                    />
                </div>

                <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                    <div>
                        <label className='label'>
                            <span className='label-text font-medium'>Date de début</span>
                        </label>
                        <input
                            type='date'
                            className='input input-bordered w-full'
                            value={popupForm.startDate}
                            onChange={(e) => setPopupForm({ ...popupForm, startDate: e.target.value })}
                        />
                    </div>
                    <div>
                        <label className='label'>
                            <span className='label-text font-medium'>Date de fin (optionnelle)</span>
                        </label>
                        <input
                            type='date'
                            className='input input-bordered w-full'
                            value={popupForm.endDate}
                            onChange={handleEndDateChange}
                            placeholder='Laissez vide pour une durée illimitée'
                        />
                        <label className='label'>
                            <span className='label-text-alt text-base-content/60'>Laissez vide pour une durée illimitée</span>
                        </label>
                    </div>
                </div>

                <div className='form-control'>
                    <label className='cursor-pointer label justify-start gap-2'>
                        <input
                            type='checkbox'
                            className='toggle toggle-primary'
                            checked={popupForm.isActive}
                            onChange={(e) => setPopupForm({ ...popupForm, isActive: e.target.checked })}
                        />
                        <span className='label-text'>Activer immédiatement</span>
                    </label>
                </div>
                <div className='form-control'>
                    <label className='label'>
                        <span className='label-text font-medium'>Type</span>
                    </label>
                    <select
                        className='select select-bordered w-full'
                        value={popupForm.type}
                        onChange={(e) => setPopupForm({ ...popupForm, type: e.target.value })}
                    >
                        <option value='info'>Info</option>
                        <option value='warning'>Warning</option>
                    </select>
                </div>
            </div>
            <div className='space-y-2'>
                <label className='label'>
                    <span className='label-text font-medium'>Routes</span>
                </label>
                <div className='space-y-4'>
                    {/* Toutes les routes */}
                    <div className='border-b pb-2'>
                        <label className='label cursor-pointer justify-start gap-2'>
                            <input
                                type='checkbox'
                                className='checkbox checkbox-primary'
                                checked={popupForm?.routes?.includes('*')}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        // Sélectionner toutes les routes
                                        const allRouteValues = [
                                            '*', '/', '/dashboard', '/produits', '/clients',
                                            '/melanges', '/selections', '/mes-capsules',
                                            '/mon-compte', '/admin'
                                        ];
                                        setPopupForm({ ...popupForm, routes: allRouteValues });
                                    } else {
                                        // Désélectionner toutes les routes
                                        setPopupForm({ ...popupForm, routes: [] });
                                    }
                                }}
                            />
                            <span className='label-text font-semibold text-primary'>🌐 Toutes les routes</span>
                        </label>
                    </div>

                    {/* Routes avec leurs enfants */}
                    <div className='space-y-4'>
                        {ROUTES.map((routeGroup) => {
                            const isAllRoutesSelected = popupForm?.routes?.includes('*');
                            const isParentSelected = popupForm?.routes?.includes(routeGroup.parent.value);
                            const isDisabled = isAllRoutesSelected;

                            return (
                                <div key={routeGroup.parent.value} className='border rounded-lg p-3 bg-base-100'>
                                    {/* Route parent */}
                                    <label className='label cursor-pointer justify-start gap-2 mb-2'>
                                        <input
                                            type='checkbox'
                                            className='checkbox checkbox-primary'
                                            checked={isAllRoutesSelected || isParentSelected}
                                            disabled={isDisabled}
                                            onChange={(e) => {
                                                const newRoutes = e.target.checked
                                                    ? [...popupForm?.routes || [], routeGroup.parent.value]
                                                    : popupForm?.routes?.filter((r) => r !== routeGroup.parent.value) || [];

                                                const filteredRoutes = newRoutes.filter(r => r !== '*');
                                                setPopupForm({ ...popupForm, routes: filteredRoutes });
                                            }}
                                        />
                                        <span className='label-text font-medium'>{routeGroup.parent.label}</span>
                                    </label>

                                    {/* Routes enfants */}
                                    {routeGroup.children.length > 0 && (
                                        <div className='ml-6 space-y-1'>
                                            {routeGroup.children.map((childRoute) => {
                                                const isChildSelected = popupForm?.routes?.includes(childRoute.value);

                                                return (
                                                    <label key={childRoute.value} className='label cursor-pointer justify-start gap-2 py-1'>
                                                        <input
                                                            type='checkbox'
                                                            className='checkbox checkbox-sm checkbox-primary'
                                                            checked={isAllRoutesSelected || isChildSelected}
                                                            disabled={isDisabled}
                                                            onChange={(e) => {
                                                                const newRoutes = e.target.checked
                                                                    ? [...popupForm?.routes || [], childRoute.value]
                                                                    : popupForm?.routes?.filter((r) => r !== childRoute.value) || [];

                                                                const filteredRoutes = newRoutes.filter(r => r !== '*');
                                                                setPopupForm({ ...popupForm, routes: filteredRoutes });
                                                            }}
                                                        />
                                                        <span className='label-text text-sm opacity-80'>{childRoute.label}</span>
                                                    </label>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <div className='modal-action mt-6'>
                <button className='btn btn-ghost' onClick={onCancel} disabled={isLoading}>
                    Annuler
                </button>
                <button
                    className='btn btn-secondary mr-2'
                    onClick={onPreview}
                    disabled={isLoading || !popupForm.title || (!temporaryContent && !popupForm.content)}
                >
                    <EyeIcon className='w-5 h-5 mr-2' />
                    Prévisualiser
                </button>
                <button
                    className='btn btn-primary'
                    onClick={handleSubmit}
                    disabled={isLoading || !popupForm.title || (!popupForm.routes || popupForm.routes.length === 0) || (!popupForm.content && !temporaryContent)}
                >
                    {isLoading ? (
                        <>
                            <span className='loading loading-spinner loading-sm'></span>
                            Chargement...
                        </>
                    ) : isCreating ? 'Créer' : 'Mettre à jour'}
                </button>
            </div>
        </>
    )
}

export default PopupForm 